import React from 'react';

const ViewToggle = ({
  currentView,
  setCurrentView
}) => {
  const viewOptions = [
    { id: 'grid', label: 'Grid', icon: '🔲' },
    { id: 'list', label: 'List', icon: '📋' },
    { id: 'images', label: 'Images', icon: '🖼️' },
    { id: 'warehouses', label: 'Warehouses', icon: '📍' },
    { id: 'surprise', label: 'Surprise Me', icon: '🎲' }
  ];

  return (
    <div className="mb-4 bg-white rounded-lg shadow-sm border p-3">
      <div className="flex flex-wrap gap-2">
        {viewOptions.map(view => (
          <button
            key={view.id}
            onClick={() => setCurrentView(view.id)}
            className={`flex items-center gap-1 px-2 py-1 rounded text-xs font-medium transition-colors ${
              currentView === view.id
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            <span>{view.icon}</span>
            <span className="hidden sm:inline">{view.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ViewToggle;